import { render, staticRenderFns } from "./LivestreamBestPracticesArticle.vue?vue&type=template&id=095d2973&scoped=true&"
import script from "./LivestreamBestPracticesArticle.vue?vue&type=script&lang=js&"
export * from "./LivestreamBestPracticesArticle.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamBestPracticesArticle.vue?vue&type=style&index=0&id=095d2973&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d2973",
  null
  
)

export default component.exports